// ------------------------------------------------------------------------
// スムーススクロール
// ------------------------------------------------------------------------
const smoothScroll = () => {
  $('a.scroll[href^="#"]').on('click', function() {
    let linkSpeed    = 400;
    let linkHref     = $(this).attr('href');
    let linkTarget   = $(linkHref == '#' || linkHref == '' ? 'html' : linkHref);
    let linkPosition = linkTarget.offset().top;
    let linkAdjust   = 0;
    $('html, body').animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, 'swing');
    return false;
  });
};



export {
  smoothScroll,
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js